/*
 * @Author: wzc
 * @Date: 2024-04-17
 * @LastEditors: wzc
 * 超赛平台 类似赛果多个主题列表 且主题带选择框
 * @LastEditTime: 2023-04-17
 * 备注：主要应于 类似于赛果中的【数据分析】主题list；多个主题
 * 【足球世界杯：赛果】
 * 【综合性赛事：赛果|小项数据分析】
 * 【CBA：赛果】
 * 【羽毛球：赛果|晋级之路】
 * 【中国网球公开赛：赛果|晋级之路】
 */

import { https_package_findAnalysisItem } from '@api/platfrom_base_api'
import formAnalysisIDToRenderThemeList_data_mixin from '@mixins/formAnalysisIDToRenderThemeList_data'
export default {
  mixins: [formAnalysisIDToRenderThemeList_data_mixin],
  data() {
    return {
      // isShowAnalysisFlag: true,
    }
  },
  methods: {
    // makeAnalysisItemParams() {
    //  每个页面单独设置不同函数来设置 this.findAnalysisItem(params) 中需要的 params
    // },
    // getMoreThemeDatas() {
    //     放到了 more_themeList.vue 中，执行获取主题数据的逻辑；可以冲当一个触发拉取主题数据的钩子函数
    // },
    async initMoreFindAnalysisItem() {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      let params = JSON.parse(JSON.stringify(this.findAnalysisItemParams))
      await this.findAnalysisItem_more(params)
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    async findAnalysisItem_more(params) {
      // 获取所有主题信息
      await https_package_findAnalysisItem(
        this.axiosBaseUrl,
        this.$axios,
        params
      )
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            const resDataArr = this.findAnalysisItemResDataToThemeListHandler(
              res.data ? res.data : []
            )
            this.themeList = resDataArr[0]
            this.themeAnalysisItemIdArr = resDataArr[1]
            this.jsonArr = resDataArr[2]
            // this.themeList = res.data.map((item) => {
            //   this.themeAnalysisItemIdArr.push(item.analysisItemId)
            //   this.jsonArr.push(item.json)
            //   let newItem = JSON.parse(JSON.stringify(item))
            //   newItem.actJson = JSON.parse(newItem.json)
            //   newItem.renderData = null
            //   if (newItem.analysisItemStyles) {
            //     // 如果 analysisItemStyles 个数只有1个，则默认选第一个，如果有多个则不需要选默认的
            //     let initAct =
            //       newItem.analysisItemStyles.length === 1 ? true : false
            //     newItem.analysisItemStyles.forEach((styleItem, styleIndex) => {
            //       if (initAct && styleIndex === 0) {
            //         styleItem.act = true
            //       } else {
            //         styleItem.act = false
            //       }
            //     })
            //   }
            //   newItem.title2RightName =
            //     newItem.analysisItemStyles && newItem.analysisItemStyles.length
            //       ? `${newItem.analysisItemStyles.length}种风格`
            //       : ''

            //   // 初始化时是否将选择框禁止
            //   newItem.filter.filterTypes.forEach((filterItem) => {
            //     filterItem.values.forEach((selectItem) => {
            //       if (filterItem.isMultiple) {
            //         // 当选中的数量大于等于最大值值时且被选中的值中没有此选项，则禁止被选
            //         // console.debug(
            //         //   'filterItem:',
            //         //   filterItem,
            //         //   newItem.actJson,
            //         //   newItem.actJson[filterItem.name],
            //         //   newItem.actJson[filterItem.name].length ===
            //         //     filterItem.maxCount &&
            //         //     !newItem.actJson[filterItem.name].includes(
            //         //       selectItem.value
            //         //     )
            //         // )
            //         if (
            //           newItem.actJson[filterItem.name] &&
            //           newItem.actJson[filterItem.name].length ===
            //             filterItem.maxCount &&
            //           !newItem.actJson[filterItem.name].includes(
            //             selectItem.value
            //           )
            //         ) {
            //           selectItem.disabled = true
            //         } else {
            //           selectItem.disabled = false
            //         }
            //       }
            //     })
            //   })
            //   return newItem
            // })
            this.refreshCallback() //根据参数，获取最新主题数据

            if (
              this.isRefresh &&
              this.refreshCallbackHandle &&
              !this.setIntervalId
            ) {
              this.refreshCallbackHandle(this.refreshCallback)
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
